import { Dispatch } from 'react'
import { useStorage, ParserOptions } from './use-storage.js'

export const useSessionStorage = <T>(
  /**
   * Be aware what strategy you choose for our key naming. Also understand our default storage format is JSON.
   * It depends wheter you have a single hostname or not how your key should look like.
   * Apps deployed on an own url are free to choose a name.
   * Shared apps should not use generic names, only when intentional and agreed between these.
   * So a key like `i18n` on shared url can lead to problems in other apps for example :)
   */
  key: string,

  /**
   * The default value when none given. Understand our default storage is JSON. So when you want to store 'light',
   * this will actually stored as '"light"'. When you want to have it as string then chooce for the next param the
   * option: { raw: true }
   */
  initialValue?: T,

  /**
   * When you do not want the JSON formatter. Be aware when once stored as JSON you need to handle this in your deserializer as well!
   * When you need just a string use { raw: true }
   * When you need something complex add the serializer and deserializer, these are also mandetory when you change
   * a format while having a storage allready. So for example you started as string, then want to go to JSON.
   */
  options?: ParserOptions<T>
): [T, Dispatch<T>] => useStorage(window.sessionStorage, key, initialValue, options)
